import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './ContentSwitcherUseStyles';

const EachSideContentHandler = props => {
  const { children, value, index } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={`${classes.ContentSwitcher}__table ${
        value !== index ? `${classes.ContentSwitcher}__table--display` : ''
      }`}
    >
      {value === index ? children : null}
    </div>
  );
};
EachSideContentHandler.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
export default EachSideContentHandler;
